import React, { useState, useEffect } from 'react'
import { Chip, Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useConfig } from 'hooks/useConfig'
import SandDriveReviewApp from 'components/Settings/SandDriveReviewApp'

const useStyles = makeStyles(theme => ({
  container: {
    position: 'fixed',
    top: 8,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: theme.zIndex.drawer + 2,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  chip: {
    backgroundColor: '#ffeb3b',
    color: '#000',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#fdd835'
    }
  }
}))

const SandDriveBanner = ({ sandDriveConfig: propConfig, refreshConfig }) => {
  const classes = useStyles()
  const { config } = useConfig()
  const [sandDriveConfig, setSandDriveConfig] = useState(propConfig)
  const [isProduction, setIsProduction] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  
  const apiUrl = config.LOGITRAC_API_URL || localStorage.getItem('LOGITRAC_API_URL')

  // Update local state when prop changes
  useEffect(() => {
    setSandDriveConfig(propConfig)
  }, [propConfig])

  // Determine if we're in production environment and fetch initial config
  useEffect(() => {
    // Production environment is specifically:
    // - logitrac.app.tssands.com (production URL from flux-prod config)
    // - Any *.logitrac.com domain (production customer domains)
    // Everything else (review apps, localhost, dev, staging) should show the banner
    const isProd = apiUrl && (
      apiUrl.includes('logitrac.app.tssands.com') ||
      apiUrl.includes('.logitrac.com') ||
      apiUrl.includes('logitrac.io')
    )
    setIsProduction(isProd)

    if (!isProd && apiUrl && refreshConfig) {
      // Initial fetch using the parent's refresh function
      refreshConfig()
    }
  }, [apiUrl, refreshConfig])

  const handleClick = () => {
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  if (isProduction) {
    return null
  }

  const getSandDriveDisplay = () => {
    if (!sandDriveConfig?.url) {
      return 'Not Configured'
    }
    
    const match = sandDriveConfig.url.match(/https:\/\/(\d+)\.review\.tssands\.com\//)
    if (match) {
      return `Review App #${match[1]}`
    }
    
    if (sandDriveConfig.url.includes('sanddrive.dev')) {
      return 'Dev/Staging'
    }
    
    if (sandDriveConfig.url.includes('localhost')) {
      return 'Localhost'
    }
    
    return 'Custom URL'
  }

  return (
    <>
      <div className={classes.container}>
        <Chip 
          label={`SandDrive: ${getSandDriveDisplay()} (Click to configure)`}
          className={classes.chip}
          onClick={handleClick}
        />
      </div>
      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle>Configure SandDrive Review App</DialogTitle>
        <DialogContent>
          <SandDriveReviewApp 
            handleClose={handleCloseModal} 
            onConfigUpdate={refreshConfig}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default SandDriveBanner